import { render, staticRenderFns } from "./TalkForm.vue?vue&type=template&id=b71adba0&"
import script from "./TalkForm.vue?vue&type=script&lang=ts&"
export * from "./TalkForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports